import type { ExpressCheckoutPosition } from '../types/StripeFeatures';
import type { CheckoutUrlRootBuilder } from './CheckoutUrlRootBuilder';

/** The Express Checkout Element (Google Pay / Link / Amazon Pay / PayPal). */
export class ExpressCheckoutPreferences {
  constructor(private readonly root: CheckoutUrlRootBuilder) {}

  enabled(): this {
    this.root.param('eco', 'auto');
    return this;
  }

  disabled(): this {
    this.root.param('eco', 'never');
    return this;
  }

  /** Include Apple Pay in the express row. */
  applePay(on = true): this {
    this.root.param('eco_apple_pay', on ? '1' : undefined);
    return this;
  }

  /** Where the express row renders relative to the card form. */
  position(position: ExpressCheckoutPosition): this {
    this.root.param('eco_position', position);
    return this;
  }
}
